
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoCZMvO_dVwQuWt_IFA3ejXxsWra10Ryi0h7y_45AkK_ndwMeta } from "/var/www/2025-09-17_17_09/pages/edo.vue?macro=true";
import { default as helpP2GGGJUNQKNdzx2PAXPtSPfifBMsOnyULli5HS_5JPUMeta } from "/var/www/2025-09-17_17_09/pages/help.vue?macro=true";
import { default as cargo_v4BjFoivdxx8B6rlEvm_45jtNCB_45n6aVLlt04COI4D_gMeta } from "/var/www/2025-09-17_17_09/pages/cargo.vue?macro=true";
import { default as indexONFIbYJYAoFuuGlNjSCzqxT8s2EmQ8Maf1W1tOc36agMeta } from "/var/www/2025-09-17_17_09/pages/index.vue?macro=true";
import { default as _91slug_93Kp6ZtyU7vQfG8mNZAk_huJiJ9WZ7EouJGk9Y_LMgTvIMeta } from "/var/www/2025-09-17_17_09/pages/[slug].vue?macro=true";
import { default as cookiedyzO__B_IE5Fdy1RqqWCTfasFcZonWrlLW1jwtXKx7oMeta } from "/var/www/2025-09-17_17_09/pages/cookie.vue?macro=true";
import { default as surveyV_caJehDZ4g5vTeHaqH5LdJg8WXI77nURO_4536jM4UuQMeta } from "/var/www/2025-09-17_17_09/pages/survey.vue?macro=true";
import { default as belarusKa_45cJOAlf7tpVffU2wqRb88Kh4YxDHxWXuaCr2EE_45vgMeta } from "/var/www/2025-09-17_17_09/pages/belarus.vue?macro=true";
import { default as bonusesjAR6jzxoOlreuxjWeKQOp05H9jr4ElMGbhHe3mxjJ_45AMeta } from "/var/www/2025-09-17_17_09/pages/bonuses.vue?macro=true";
import { default as apieI9QeyWXU5DEzvwii3WhAjBPZwJ6pe9LqI0B_vaeI_45UMeta } from "/var/www/2025-09-17_17_09/pages/dev/api.vue?macro=true";
import { default as cmspEZAGktFDp_45I707B7ImkSkkxG_1xuLoISA92J5MEGasMeta } from "/var/www/2025-09-17_17_09/pages/dev/cms.vue?macro=true";
import { default as konkurspuF7yIMqQ1qu8MxdnN9pu_45jUFkK3Xb8SM572eZXWDpIMeta } from "/var/www/2025-09-17_17_09/pages/konkurs.vue?macro=true";
import { default as successDY1lx3Notfp_45Bg3s4CGEbtF2zx6YWzF8qvOA5JW1bgEMeta } from "/var/www/2025-09-17_17_09/pages/success.vue?macro=true";
import { default as vacancyyGNbWRdSYA8Dl44sj0Q_ZLyj_UGfwKtzpx_qYRPL7LEMeta } from "/var/www/2025-09-17_17_09/pages/vacancy.vue?macro=true";
import { default as contactsfuLql11Go9Uvt_45bVMLeyWu4vY72zVabPXEYwpe47STIMeta } from "/var/www/2025-09-17_17_09/pages/contacts.vue?macro=true";
import { default as giveawayEf4M_45_tjZLQlqc46qS1RqLeMlepBKV9LCIWOPu21I1IMeta } from "/var/www/2025-09-17_17_09/pages/giveaway.vue?macro=true";
import { default as guide_45lkXCAUSouk4AwOCVaQWwi77iofYToNhhmU1GBerT6hQd0Meta } from "/var/www/2025-09-17_17_09/pages/guide-lk.vue?macro=true";
import { default as servicesuHcJFYUBSNxAye5mGY7kqVfyxk7NT6C96fGMNqgycjYMeta } from "/var/www/2025-09-17_17_09/pages/services.vue?macro=true";
import { default as telegramMWFnBbYHyvL2ovPVKtBmMdXX_45bMC4ql7X96RofWqFzEMeta } from "/var/www/2025-09-17_17_09/pages/telegram.vue?macro=true";
import { default as documentsP6cYRw6IOayMEKU12OFRXP_45dJ_45dZVjhd_45xVIyICbtjIMeta } from "/var/www/2025-09-17_17_09/pages/documents.vue?macro=true";
import { default as franchiseknpvIWJKCpoAXKwx_mRkNRGekklNsWdsx4sTU39VBFgMeta } from "/var/www/2025-09-17_17_09/pages/franchise.vue?macro=true";
import { default as insuranceCDYgsJmxQ_45pvDcUq6FCp_TOA8Mwtl2yJmds0owxRwogMeta } from "/var/www/2025-09-17_17_09/pages/insurance.vue?macro=true";
import { default as kirghiziaIaeS9OYoRap_45RJio5wP6U2gJBUTb9_45sZ5otO3SB8p_AMeta } from "/var/www/2025-09-17_17_09/pages/kirghizia.vue?macro=true";
import { default as mapScheme5F9DbOsGfl3vDpGN2JaD0jMs9ZI0saMcC3hIn4xcLUkMeta } from "/var/www/2025-09-17_17_09/pages/mapScheme.vue?macro=true";
import { default as _91id_93JiM7ug86MhrzWrEa4Jqu_igibdatdvjCXQRwa4x9N1gMeta } from "/var/www/2025-09-17_17_09/pages/news/[id].vue?macro=true";
import { default as return_45sdg3hfZFrq20SNHfmqe69qmO_JnaJs_b_455lE3gYase4ywMeta } from "/var/www/2025-09-17_17_09/pages/return-sd.vue?macro=true";
import { default as smsClientZ_45sQmpL2MLs5ST2C5EJE2_3pU_451_NLPvHGJWXeCmMHkMeta } from "/var/www/2025-09-17_17_09/pages/smsClient.vue?macro=true";
import { default as terminalsLowU6x5iZA4ZfhdIhNcpUckU1AOrnlsBa_L0kGuOWCIMeta } from "/var/www/2025-09-17_17_09/pages/terminals.vue?macro=true";
import { default as iframeeQyDfD4_JPqjRgsuiYseQu9WZp_458_45CEQeajhfzDWls8Meta } from "/var/www/2025-09-17_17_09/pages/dev/iframe.vue?macro=true";
import { default as directionsUEaDzFm4U7MhLZhUob14KfUjl3ME3jPtJmiLNs3oiGUMeta } from "/var/www/2025-09-17_17_09/pages/directions.vue?macro=true";
import { default as kazakhstanjokoH6sRPs73jBUTxwh5jWUA4Z4Z7G01ykbsV_R1k7gMeta } from "/var/www/2025-09-17_17_09/pages/kazakhstan.vue?macro=true";
import { default as indexruSuy6xSjE62ficiSZaBBefn2SRTyCOa2hzGXsSDYMoMeta } from "/var/www/2025-09-17_17_09/pages/news/index.vue?macro=true";
import { default as svghggEFqrFMmg461NcgIf2_45mH5am_45oSZwLdPwkT1Q5TE0Meta } from "/var/www/2025-09-17_17_09/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failUzshK5xTxG9K_3yYoWxJohV5k7QYZ2yZJWOAkZwdmiMMeta } from "/var/www/2025-09-17_17_09/pages/vzpay-fail.vue?macro=true";
import { default as constructoruy_45nuX8zIUBiOS3rNu4dooQZErzjYGOBuWgq5HfSY4MMeta } from "/var/www/2025-09-17_17_09/pages/constructor.vue?macro=true";
import { default as indexGqdTTKfJwk4K_Q_459609uQwA0zQBHZxg206cuIr0w2hcMeta } from "/var/www/2025-09-17_17_09/pages/gifts/index.vue?macro=true";
import { default as informationLzjYRjQ4kgmCEvrnBYy_45INd3oAVbM5xAt7J57QlO8o0Meta } from "/var/www/2025-09-17_17_09/pages/information.vue?macro=true";
import { default as claim_45filingvA1HLENsoR_pCHXtjm0ABwYmWuiKxpcdJ42u4RhT31kMeta } from "/var/www/2025-09-17_17_09/pages/claim-filing.vue?macro=true";
import { default as _91type_938lXjTj9Aw_45iJJLKvNdBH1DgF_npbF93u1PTEvlWyvBkMeta } from "/var/www/2025-09-17_17_09/pages/gifts/[type].vue?macro=true";
import { default as marketplaces03P3A2a_45Mya___45XX2FCXHhewmWg2H8pwPANFX3rSqnEMeta } from "/var/www/2025-09-17_17_09/pages/marketplaces.vue?macro=true";
import { default as networkshopsU00EncXdqays6kQRdDrx_sfS_f154EsAAAbzYlUTqe0Meta } from "/var/www/2025-09-17_17_09/pages/networkshops.vue?macro=true";
import { default as online_45storeqBwWSmwFPR1zn3zczyWwDRODIjEGnQNvOimJk5P2lBAMeta } from "/var/www/2025-09-17_17_09/pages/online-store.vue?macro=true";
import { default as managensZDy1Gkbv8hCY5aRzDuyKhBQ4dTjygvyXOMTUWZjqMMeta } from "/var/www/2025-09-17_17_09/pages/order/manage.vue?macro=true";
import { default as registrationIwlpK2xrVunpzqQONFsSLdSJ49Sf_45qQr25KkPL3rlzsMeta } from "/var/www/2025-09-17_17_09/pages/registration.vue?macro=true";
import { default as safe_45custodyh_jWCxcyJumj5rlq_456b1r8LZgYC6_45TikfNfg1siKW1oMeta } from "/var/www/2025-09-17_17_09/pages/safe-custody.vue?macro=true";
import { default as imagejCgXeG2Eu4U6gu5Imm6fLMPrwDBcQRZ2aCcwk4HdvH4Meta } from "/var/www/2025-09-17_17_09/pages/ui-kit/image.vue?macro=true";
import { default as indexKQ1JfZt9nDz1qUSD5ECqERiH2J_H0oCO29K_IC9HxtYMeta } from "/var/www/2025-09-17_17_09/pages/ui-kit/index.vue?macro=true";
import { default as bagBQRo49HZnnjyT1Ghw7eFSMEnx5OKBfczkL0y4qKbHDUMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/bag.vue?macro=true";
import { default as box_45Q2MYkFkm8ecYxljZqf9U7_j0MaKd7VqxgVAAV5h9ywMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loading16A0D6c90gRC02N7LRTCdKz8kMRK3rk1OAcL0v7hziQMeta } from "/var/www/2025-09-17_17_09/pages/cargo-loading.vue?macro=true";
import { default as happybirthdaycRW0_45tTTnrHIWVcEPS5mJLASrRJSqF7Elv7ncbDPqYUMeta } from "/var/www/2025-09-17_17_09/pages/happybirthday.vue?macro=true";
import { default as manage3YrlWqXAQlJkB_NGROP_45vANL52rU5KmtXkssRfLwQVYMeta } from "/var/www/2025-09-17_17_09/pages/iframe/manage.vue?macro=true";
import { default as authVUs_v0b5iVicsxopo1ViI0TMosR6zad4ORKu6UF4G1sMeta } from "/var/www/2025-09-17_17_09/pages/personal/auth.vue?macro=true";
import { default as indexxgqsgMzRTN8La2_453sL4_45K_45J6uTi3wgu340RyugIZRKgMeta } from "/var/www/2025-09-17_17_09/pages/tariffs/index.vue?macro=true";
import { default as publicWLV4HH03ASR_itcDdupAzSvezjmKxgKDOZMNvf1xiPAMeta } from "/var/www/2025-09-17_17_09/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerXJPem710YV2GwFo02YGWDmVC2D6ml1PYzcx6QVSc_45HQMeta } from "/var/www/2025-09-17_17_09/pages/already-answer.vue?macro=true";
import { default as tariffszZaYWMt4dAbK9HBJpMoX3vz_45AhnT7P2A2hzIEY_0qkoMeta } from "/var/www/2025-09-17_17_09/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93RXaBFaPsby7H4r2nvAUzEb3yA0t8aU5xZ4Hy1LjPoyUMeta } from "/var/www/2025-09-17_17_09/pages/order/pay/[id].vue?macro=true";
import { default as index2FUlinvok4hBN_45mZ_62JgwGC5fmAHbn_oRvU_QeneykMeta } from "/var/www/2025-09-17_17_09/pages/personal/index.vue?macro=true";
import { default as privacy_45policyirBqkMI3lJGMQe_45NlqfaIlHy7TbUvlcZ_x7lCbOm6aAMeta } from "/var/www/2025-09-17_17_09/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93zdmwfjFuA15A5vnWHPIYpO5Wb4sHgGKynjlOv11P_45s4Meta } from "/var/www/2025-09-17_17_09/pages/welcome/[hash].vue?macro=true";
import { default as indexsmwM91Tp6DqTBzvleyRBimzh174BmphPtUIfe_45bsreAMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaE8mICEVPDvosRznQakdnFUGhFUHu7oaclTxPsfa00twMeta } from "/var/www/2025-09-17_17_09/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsff0i_91iKka4JnB7MRNJg9iGaJUMS4rXwmY4ALYgQdcMeta } from "/var/www/2025-09-17_17_09/pages/payment-methods.vue?macro=true";
import { default as qr_45infoRcj_45LuFhy8A6FjeVbYmxOgiepfNMhGP45EJqmQxs9lYMeta } from "/var/www/2025-09-17_17_09/pages/payment/qr-info.vue?macro=true";
import { default as successHI7GVWj2hr2Q4HV0K9fZRxGtyNfPsktk878x4xosp1IMeta } from "/var/www/2025-09-17_17_09/pages/payment/success.vue?macro=true";
import { default as importCS435faeuANH4vaBa9o_45huXhzX6nFBVL_8_45DNb5gT0MMeta } from "/var/www/2025-09-17_17_09/pages/personal/import.vue?macro=true";
import { default as logout1FkCG0rJw98_KDjrL16LbKWMg5UZefgveyKfPSxGAJIMeta } from "/var/www/2025-09-17_17_09/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryWm4Ym6HYyXRSpdlvex3aCSsIO2Q0QD0iSPB2CUxhzT4Meta } from "/var/www/2025-09-17_17_09/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryJSijtzzC_fMVQLhxiNbyNnxYIwZ26JiBTePfW4WcHH4Meta } from "/var/www/2025-09-17_17_09/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024YG3BhNd_45cycAC6vmLLrdqIZWpup_Th39vcUXuBCoemwMeta } from "/var/www/2025-09-17_17_09/pages/happynewyear2024.vue?macro=true";
import { default as ozongOHfAX6AttlSxJDvbJ5zmmZBqK86f6bAvXlg6AP1tc0Meta } from "/var/www/2025-09-17_17_09/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failziHKaUu_45V1otUUjwG_450_SuOgtJWrr1zulnDDuf_45pgucMeta } from "/var/www/2025-09-17_17_09/pages/payment/pay-fail.vue?macro=true";
import { default as accountgCs28i8iZxCnsrwmNbiPW22JqYgRrueFu38wCPwzh1MMeta } from "/var/www/2025-09-17_17_09/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsMi6eOXcCL2ReV1tTd9SyLBw__45SMXUFIUFi06__YaVwMMeta } from "/var/www/2025-09-17_17_09/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completedVtQnyur_45520CtD2L3H7DUBPiQOP1mt23O6XK6__45SzsYMeta } from "/var/www/2025-09-17_17_09/pages/survey-completed.vue?macro=true";
import { default as directionTdHZWQocHq7Yx3_Ms3BWW9ACzr6x7Gm9NBbhyPb2PywMeta } from "/var/www/2025-09-17_17_09/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupb2IvNDwdyH5CRI2xGG62FJNXMt3bVMDiDN_y0iVeemkMeta } from "/var/www/2025-09-17_17_09/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoGac5JBn6_45zMNI9DnkClMYIfDTSoslhXHSs6RDTGUmU8Meta } from "/var/www/2025-09-17_17_09/pages/free-pickup-cargo.vue?macro=true";
import { default as calculator7_45vN4ZYgW0b5wN2JnIwDj0WOmkwDC33ajYF_45qMx7ZsQMeta } from "/var/www/2025-09-17_17_09/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesPpHpshJhcW_NO_45iwyfLEs_45CB7W6hCLBf7pB1LJcNrQ4Meta } from "/var/www/2025-09-17_17_09/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93uI_wQ_ky7TANwaQIsGdVLR4L73_zHsvDVuDfSZnPF1sMeta } from "/var/www/2025-09-17_17_09/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoHISj1NSDwX10aGs6jcfotrDuVdmm8IKk4gYlpOOGc_4Meta } from "/var/www/2025-09-17_17_09/pages/payment/card-info.vue?macro=true";
import { default as discountUxdWtgHbOr1_45IZdtT9rYczv_457lN1kTn7P1SKoLLo9cIMeta } from "/var/www/2025-09-17_17_09/pages/personal/discount.vue?macro=true";
import { default as hard_45boxHzhXRQLapHECF33Qm00POXfvTuCHb1cUu8YOpcVQ3nUMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receipt1h8cA0JfdES1znxERkSbDPEmEpYGsb2BhA0XGztON5AMeta } from "/var/www/2025-09-17_17_09/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917OAhDPEHpUrTtMmxGVQPHERa0raV222FRBHeiO2_45Wg40Meta } from "/var/www/2025-09-17_17_09/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationEbV5Wahse_45xFoer4Kr2Gx2Vh3OVH2oGGDW_oXBgsbuMMeta } from "/var/www/2025-09-17_17_09/pages/mobile-application.vue?macro=true";
import { default as indexK26iQuvZNZ9rqcRqbJrVs7WG94H3iFofdBBg_45ckYVSoMeta } from "/var/www/2025-09-17_17_09/pages/order/create/index.vue?macro=true";
import { default as index7YncM7YXytglJck14nkQHy7zMTphf_r_J7kLMeTAQbYMeta } from "/var/www/2025-09-17_17_09/pages/run-schedule/index.vue?macro=true";
import { default as boatMVwpzQIVHK7yWyBXmzw4kf6NDin6msl7XlpaghWGEt8Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaJmZt4_45aqya0OV6q_4563jYnRlnujqXkw26FtgcCGoGaK8Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93_MmdOLb1FE8uVu1DlpIsOiZSh0w54BQL9_EXfgPrbLAMeta } from "/var/www/2025-09-17_17_09/pages/tariffs/[location].vue?macro=true";
import { default as cardboardPKMaoPgRgJgUem10msbWfqfERZ4yUFHuZOdiA8MgjZQMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodes1V_L9BQkQPL_aCCmFDV14Niqnw_45B27o8Dm_45V1gHJct4Meta } from "/var/www/2025-09-17_17_09/pages/personal/promocodes.vue?macro=true";
import { default as benchtKa4SFkMcki_kWAm3j6lKAs6XmekdRpPyaNLqOmcrrQMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/bench.vue?macro=true";
import { default as books10o9vaILXzJV_45HQpCcW_45Z7zpAqbs4WMO083djJ9EdiwMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/books.vue?macro=true";
import { default as cableZB0MCCuS3OcuJFMvRBIUIbTygT7MayqYspSHgHYWeFEMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/cable.vue?macro=true";
import { default as chairOIU1q9AlgL67R2DQVQ_45RtGO_kGszFh5JcDKR_45GfRgqsMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsEYGRZhyWR1A4Xh4juqSTdFC6ISml_6W6p2pId6ZGr9UMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/goods.vue?macro=true";
import { default as indexnosgkx3ZuuD1vI5so1_45OmXhB7oJgSU50rcyK8_NVPcMMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/index.vue?macro=true";
import { default as metal5gX8n7L4841WJvdS_45kgBBbut875E27SmCYH2XncM0eYMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/metal.vue?macro=true";
import { default as piano5OT8fL9Piomy8IYlvzo_45tvO4HgT46drvS7YoMhf1s5gMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/piano.vue?macro=true";
import { default as pipes3yPOQ8w8kSayaX1oMerI9woV4xnizbK1J_HJK07vM1IMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsmOXO6BjBM4GaEAfWyGdRWYG1_45q57jW4flmGExiUwWb8Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxWt2_45TkQmjbINto_6qv9lxd701MMGvv5GJNWrqHRt_45GsMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93dKlWUxK4pM_45GUmQik1_45zuJ2lviHWPSv2lQSTz7vYhYoMeta } from "/var/www/2025-09-17_17_09/pages/personal/bonus/[tab].vue?macro=true";
import { default as printUXXljtBFpvflJvhqVSLyDGt8gwITb_45ccaQjDYDIzWOMMeta } from "/var/www/2025-09-17_17_09/pages/personal/order/print.vue?macro=true";
import { default as dishesEtjlYFaMCEqOvw7ewODDQ8J9_45OpE_45fsazQVLzPp2_455QMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/dishes.vue?macro=true";
import { default as engine_575yAtYbEXbA0av5uOz7vbQMBqzGuW5s0maky8y_45boMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberoLb7uy3XxxdD6x3tMsb6Cgbb4qdpVcn5Xi_GLfCZimMMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsp_45lUvEPxgk1rpGnyuT8cx4j6cCjCyoRBqUcpSrUBGKUMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmh0CNGvbo3rjQ8s137SPNyOcHs_45f7ieHD1f5Z_45z0_7GMMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingRm91PhjK4s7L4uGqbOTn_i7eUys7ZW8n5NwMXtRtJ9AMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitaloBL_3BO6PN6wuemD_hWL_CVtEp_45_5M96nPVralHpYb0Meta } from "/var/www/2025-09-17_17_09/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_938mdyc1Mf6R9oUR1gvuJV6wiEXJ1EQJ9J8bQUl_NOwkoMeta } from "/var/www/2025-09-17_17_09/pages/personal/order/[guid].vue?macro=true";
import { default as create_45LY_uTJeRE6VHmH5rK1_z48_45z3fl_45iMbsgx6yY_455aLEMeta } from "/var/www/2025-09-17_17_09/pages/personal/order/create.vue?macro=true";
import { default as index_45uAcEVM2kfPaZUi3EPQ57GYvxK3RhIR5jBYp33xWoVgMeta } from "/var/www/2025-09-17_17_09/pages/safekeep/create/index.vue?macro=true";
import { default as barrels8GWpMlaAs6h0uyfbIHpScSgkXMAaVLNr_452Q0u_45IyB0QMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesf45SnjRBJojBLjUUSViP3W3Tf_45qp5iHClWQOl_45auxRYMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileL4zgujm4n4NCkErtGB5jOFZ15_E1R5rASC3_45fgAE4ygMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerHfkwuaeTlJvr_rN8Gi3wkRNu8jMgl40m1C1xvsch49AMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagemp679RcVkuCloNdfRoQ4_45M_0Vn9x2_6AQvQwCfrBHt8Meta } from "/var/www/2025-09-17_17_09/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45success9bYRr17nz0yZluhMeVlOvcWlyXv_45SzdeirrLyDQg4bQMeta } from "/var/www/2025-09-17_17_09/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageH9PjuvQxGpUTmg_459o5HEWQvhCoaOTPs6igqI0xRYjFAMeta } from "/var/www/2025-09-17_17_09/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriescXoP5jDXfSoc9nTXLGN1VbMz_45HbeQh4bke6ayWevRL8Meta } from "/var/www/2025-09-17_17_09/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93DMHotGsSLy7lY1inRz33NdzDmxYLbiQjNhMH2gHoGTAMeta } from "/var/www/2025-09-17_17_09/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_93SLVzRhSXoGA88V0x5V5td0Q_45rSEviJQIj04T_WZif_45UMeta } from "/var/www/2025-09-17_17_09/pages/run-schedule/[location].vue?macro=true";
import { default as furnituremJ3aNKAeg3fhRq6BxQ3zIV6e0usIiS0ohub8jqMdoxEMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedc3dsnPIGV3E3CAWcXwup2yKUmJ3FOg5QT5qEaTaTImYMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bike563mclbVaA9f66frJa4BezSywvVqDLzcUgL51ND1kK4Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_931bz2EoO1KL07z6HkaqB6Q_45_45N78kl6inpKw3NCmE_0A8Meta } from "/var/www/2025-09-17_17_09/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_9319bKZerSPQEF1msCMvQQK0lvvGgZbLGK6YZwQppjbi4Meta } from "/var/www/2025-09-17_17_09/pages/personal/orders/[...tab].vue?macro=true";
import { default as _91guid_93pHdYT7l_45jlsxvnIIQzQE_B4XuaU2UtHL4SWGeP_jl3EMeta } from "/var/www/2025-09-17_17_09/pages/personal/safekeep/[guid].vue?macro=true";
import { default as createHWgXszxmKriHdJn8AeZDkFiRQxbvl0S9_JA9J0WDPnIMeta } from "/var/www/2025-09-17_17_09/pages/personal/safekeep/create.vue?macro=true";
import { default as auto_45partsRWdHUJbkd8BKztixkRxSwIo_45wEU1zTDF3meAsagLUWIMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersegixT1ZhWyp6rJiPluTFZDeDlLR6zd0Q8lmOJwG_45XV4Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargodsomD_Qr9ERgpMrA0rii3NqkQtkmdeE99HY1jFQpxCkMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileCTS7sCcADzzGWf36_q08PoCA5D_45ygznfjzxKC0zJhecMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexUILYy_G2wGd8543K5p47C57Dn4SwC4v3X_45kJ83GxFH8Meta } from "/var/www/2025-09-17_17_09/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketNlng7NoYxsYbCK6Y5HIy9lDRp3rpQWEru20XKHVKrz0Meta } from "/var/www/2025-09-17_17_09/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesLoz4wufWsqfNUHTMGaRututh6d3s6QlfLz6nCJxuERsMeta } from "/var/www/2025-09-17_17_09/pages/personal/orders/templates.vue?macro=true";
import { default as indexKGGqorNm63b6Bh6kCMwinucDsdmQcjkCA6i3_45azH1MoMeta } from "/var/www/2025-09-17_17_09/pages/personal/contractors/index.vue?macro=true";
import { default as _91guid_93x9j4X1_45dH2w5ufL6sLkRUlIClVwreMGheiM6YZwbRD0Meta } from "/var/www/2025-09-17_17_09/pages/safekeep/administer/[guid].vue?macro=true";
import { default as refrigeratorRF9mfoZ_gVqipDYRtWzUb2BtiaHy19dS1BTfDOmXptEMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93arLxQp_45f8TFlmZfGvmZ3UJCcxUJWRyvP5FYc_45m9kciMMeta } from "/var/www/2025-09-17_17_09/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexHgD95M4z4Ov6ENL0EhbrBcA7QcE9zXyvxBcaytQOiO4Meta } from "/var/www/2025-09-17_17_09/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91_46_46_46tab_93UF6Apujs_ZL9tQbBEDKpnB7OMoj7UrN2iZCRusjGC90Meta } from "/var/www/2025-09-17_17_09/pages/personal/safekeeps/[...tab].vue?macro=true";
import { default as _91guid_939z70pJO9Ot93Q8J6Vpxl7El08305bV7RHhFWy6v99kcMeta } from "/var/www/2025-09-17_17_09/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsAOFfZMWxyO22v7J8tUSqf8m1YPFE5aY8p8z2Eg9EfZEMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexfl95HjZiIMT0lIbhIJPHeF6yBIhSb9buLDqR0fYmPuYMeta } from "/var/www/2025-09-17_17_09/pages/personal/group-printing/index.vue?macro=true";
import { default as indexOqMepeGWO3zwc3BM_45Llae_4oST7snMUcWYrhNXD2lLsMeta } from "/var/www/2025-09-17_17_09/pages/personal/multi-delivery/index.vue?macro=true";
import { default as _91_46_46_46tab_93HB3tX14GphpRRu_LQkIjQWWujE6ONxMlcO7L5UhMNFAMeta } from "/var/www/2025-09-17_17_09/pages/personal/orders-ozon/[...tab].vue?macro=true";
import { default as medical_45devicesvFWQlYde_45Q6Fzc526jzkhY20C5ODzeZnPTaUJ8uSdCMMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93AYzBQYYfjUCqng1w2NxUrZL_aXJZ4AxbfKxAmyhICGEMeta } from "/var/www/2025-09-17_17_09/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93BupFzB6BMRfOLC5YiQOwNzkovf6wZNrSlJMTs8uOOHIMeta } from "/var/www/2025-09-17_17_09/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93gq6P3LZHSLCDRlosW6DvHw_45fi1EQDzOWKMRDT_UN_KQMeta } from "/var/www/2025-09-17_17_09/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmente0_Nd5qf_452H_45L_C6vfO9op54GZ1TVEXyM8NGYr7kwBAMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsP0m_S36lx5_45L_452_45W0rsAVK69krg8Jit2n1QMHKsJ5tYMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsH6W771QbnUbfSHz_451QnLY2OqQiIV61QbNV6H0uN0OK0Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentxp7_AaJcinml3we2pViT9Zqz1aqKOThUQSoAyyHY6Z0Meta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportation7Z9Z3zz7sH_x_KsVQL_45ghroizVp1tiKfAfVrN1FoXUsMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_936Gkk_YpAwAqz5zleUs8UkdgaZzIZjpegN2JQI0ungQ0Meta } from "/var/www/2025-09-17_17_09/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationa5gKtXU8rtMtVhEzITzRTUYMdxkkU3vDi9SCvjaBEQQMeta } from "/var/www/2025-09-17_17_09/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-09-17_17_09/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-09-17_17_09/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-09-17_17_09/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-09-17_17_09/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93Kp6ZtyU7vQfG8mNZAk_huJiJ9WZ7EouJGk9Y_LMgTvIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-09-17_17_09/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: surveyV_caJehDZ4g5vTeHaqH5LdJg8WXI77nURO_4536jM4UuQMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-09-17_17_09/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-09-17_17_09/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-09-17_17_09/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-09-17_17_09/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurspuF7yIMqQ1qu8MxdnN9pu_45jUFkK3Xb8SM572eZXWDpIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-09-17_17_09/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-09-17_17_09/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsfuLql11Go9Uvt_45bVMLeyWu4vY72zVabPXEYwpe47STIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-09-17_17_09/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-09-17_17_09/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-09-17_17_09/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-09-17_17_09/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-09-17_17_09/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-09-17_17_09/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-09-17_17_09/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-09-17_17_09/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapScheme5F9DbOsGfl3vDpGN2JaD0jMs9ZI0saMcC3hIn4xcLUkMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93JiM7ug86MhrzWrEa4Jqu_igibdatdvjCXQRwa4x9N1gMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-09-17_17_09/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-09-17_17_09/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-09-17_17_09/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-09-17_17_09/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-09-17_17_09/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-09-17_17_09/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexruSuy6xSjE62ficiSZaBBefn2SRTyCOa2hzGXsSDYMoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-09-17_17_09/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-09-17_17_09/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructoruy_45nuX8zIUBiOS3rNu4dooQZErzjYGOBuWgq5HfSY4MMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexGqdTTKfJwk4K_Q_459609uQwA0zQBHZxg206cuIr0w2hcMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-09-17_17_09/pages/information.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-09-17_17_09/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_938lXjTj9Aw_45iJJLKvNdBH1DgF_npbF93u1PTEvlWyvBkMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-09-17_17_09/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-09-17_17_09/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-09-17_17_09/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-09-17_17_09/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-09-17_17_09/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-09-17_17_09/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-09-17_17_09/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-09-17_17_09/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdaycRW0_45tTTnrHIWVcEPS5mJLASrRJSqF7Elv7ncbDPqYUMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manage3YrlWqXAQlJkB_NGROP_45vANL52rU5KmtXkssRfLwQVYMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-09-17_17_09/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-09-17_17_09/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-09-17_17_09/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffszZaYWMt4dAbK9HBJpMoX3vz_45AhnT7P2A2hzIEY_0qkoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: index2FUlinvok4hBN_45mZ_62JgwGC5fmAHbn_oRvU_QeneykMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-09-17_17_09/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-09-17_17_09/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-09-17_17_09/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importCS435faeuANH4vaBa9o_45huXhzX6nFBVL_8_45DNb5gT0MMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logout1FkCG0rJw98_KDjrL16LbKWMg5UZefgveyKfPSxGAJIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-09-17_17_09/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-09-17_17_09/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024YG3BhNd_45cycAC6vmLLrdqIZWpup_Th39vcUXuBCoemwMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozongOHfAX6AttlSxJDvbJ5zmmZBqK86f6bAvXlg6AP1tc0Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountgCs28i8iZxCnsrwmNbiPW22JqYgRrueFu38wCPwzh1MMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-09-17_17_09/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completedVtQnyur_45520CtD2L3H7DUBPiQOP1mt23O6XK6__45SzsYMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-09-17_17_09/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-09-17_17_09/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-09-17_17_09/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculator7_45vN4ZYgW0b5wN2JnIwDj0WOmkwDC33ajYF_45qMx7ZsQMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-09-17_17_09/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountUxdWtgHbOr1_45IZdtT9rYczv_457lN1kTn7P1SKoLLo9cIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-09-17_17_09/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917OAhDPEHpUrTtMmxGVQPHERa0raV222FRBHeiO2_45Wg40Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-09-17_17_09/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexK26iQuvZNZ9rqcRqbJrVs7WG94H3iFofdBBg_45ckYVSoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-09-17_17_09/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-09-17_17_09/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodes1V_L9BQkQPL_aCCmFDV14Niqnw_45B27o8Dm_45V1gHJct4Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93dKlWUxK4pM_45GUmQik1_45zuJ2lviHWPSv2lQSTz7vYhYoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printUXXljtBFpvflJvhqVSLyDGt8gwITb_45ccaQjDYDIzWOMMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-09-17_17_09/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_938mdyc1Mf6R9oUR1gvuJV6wiEXJ1EQJ9J8bQUl_NOwkoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create_45LY_uTJeRE6VHmH5rK1_z48_45z3fl_45iMbsgx6yY_455aLEMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/order/create.vue")
  },
  {
    name: "safekeep-create",
    path: "/safekeep/create",
    meta: index_45uAcEVM2kfPaZUi3EPQ57GYvxK3RhIR5jBYp33xWoVgMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/safekeep/create/index.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-09-17_17_09/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-09-17_17_09/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriescXoP5jDXfSoc9nTXLGN1VbMz_45HbeQh4bke6ayWevRL8Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-09-17_17_09/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_9319bKZerSPQEF1msCMvQQK0lvvGgZbLGK6YZwQppjbi4Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/orders/[...tab].vue")
  },
  {
    name: "personal-safekeep-guid",
    path: "/personal/safekeep/:guid",
    meta: _91guid_93pHdYT7l_45jlsxvnIIQzQE_B4XuaU2UtHL4SWGeP_jl3EMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/safekeep/[guid].vue")
  },
  {
    name: "personal-safekeep-create",
    path: "/personal/safekeep/create",
    meta: createHWgXszxmKriHdJn8AeZDkFiRQxbvl0S9_JA9J0WDPnIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/safekeep/create.vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexUILYy_G2wGd8543K5p47C57Dn4SwC4v3X_45kJ83GxFH8Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketNlng7NoYxsYbCK6Y5HIy9lDRp3rpQWEru20XKHVKrz0Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesLoz4wufWsqfNUHTMGaRututh6d3s6QlfLz6nCJxuERsMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexKGGqorNm63b6Bh6kCMwinucDsdmQcjkCA6i3_45azH1MoMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/contractors/index.vue")
  },
  {
    name: "safekeep-administer-guid",
    path: "/safekeep/administer/:guid()",
    component: () => import("/var/www/2025-09-17_17_09/pages/safekeep/administer/[guid].vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93arLxQp_45f8TFlmZfGvmZ3UJCcxUJWRyvP5FYc_45m9kciMMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexHgD95M4z4Ov6ENL0EhbrBcA7QcE9zXyvxBcaytQOiO4Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-safekeeps-tab",
    path: "/personal/safekeeps/:tab(.*)*",
    meta: _91_46_46_46tab_93UF6Apujs_ZL9tQbBEDKpnB7OMoj7UrN2iZCRusjGC90Meta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/safekeeps/[...tab].vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_939z70pJO9Ot93Q8J6Vpxl7El08305bV7RHhFWy6v99kcMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexfl95HjZiIMT0lIbhIJPHeF6yBIhSb9buLDqR0fYmPuYMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexOqMepeGWO3zwc3BM_45Llae_4oST7snMUcWYrhNXD2lLsMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "personal-orders-ozon-tab",
    path: "/personal/orders-ozon/:tab(.*)*",
    meta: _91_46_46_46tab_93HB3tX14GphpRRu_LQkIjQWWujE6ONxMlcO7L5UhMNFAMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/orders-ozon/[...tab].vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93AYzBQYYfjUCqng1w2NxUrZL_aXJZ4AxbfKxAmyhICGEMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93BupFzB6BMRfOLC5YiQOwNzkovf6wZNrSlJMTs8uOOHIMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93gq6P3LZHSLCDRlosW6DvHw_45fi1EQDzOWKMRDT_UN_KQMeta || {},
    component: () => import("/var/www/2025-09-17_17_09/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-09-17_17_09/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-09-17_17_09/pages/shippingtypes/personalitemstransportation.vue")
  }
]